import { Outlet, Navigate, useNavigate } from "react-router-dom";
import { useEffect, useRef } from "react";
import { useAuth } from "@conductor/context/AuthContext.jsx";
import useToast from "@shared/hooks/useToast.jsx";
import Spinner from "@shared/componets/feedback/Spinner/Spinner.jsx";
import Particules from "../partials/Particules/Particules";

const LoginLayout = () => {
    const { userData, loadingAuth } = useAuth();
    const { newToast } = useToast();
    const navigate = useNavigate();
    const fired = useRef(false);

    useEffect(() => {
        if (!loadingAuth) return;
        if (userData && !fired.current) {
            fired.current = true;
            newToast("Usted se encuentra logueado", "info");
            navigate("/", { replace: true });
        }
    }, [userData, newToast, navigate]);

    if (loadingAuth) return <Spinner />;


    if (userData) return null;

    return (
        <Particules>
            <Outlet />
        </Particules>
    );
};

export default LoginLayout;
